import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { get, post } from '../../util/request';
import { userInfo } from '../../redux/slice';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import SubmitSuccessPopUp from "../page/submitSuccessPopUp";
import { useHistory } from 'react-router';

const PayPalCheckoutButton = ({ TaxYear }) => {
  const user = useSelector(userInfo);
  const history = useHistory();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleOk = async () => {
    setIsError(false);
    setIsModalOpen(false);
  }

  const handleSubmit = async () => {
    const detail = {
      TaxFilingYear: TaxYear,
      CustomerID: user.clientID,
      Tab: "Payment"
    }
    const params = {
      ...detail,
      accessToken: user.accessToken,
      userId: user.userId
    }

    await post('/taxQuestionnaire/update', params).then((data) => {
      if (data.message === 'Success') {
        setIsError(false);
        setIsModalOpen(true);
      }
      else {
        setIsError(true);
      }
    }).catch(() => {
      setIsError(true);
    });
  }

  return (
    <>
      <SubmitSuccessPopUp isModalOpen={isModalOpen} title={isError ? 'ERROR' : t('PAYMENT SUCCESSFUL')} content={isError ? t('UNEXPECTED_ERROR_desc') : ''} handleOk={handleOk} handleCancel={handleOk} icon={isError ? 'submit-error' : 'submit-success'} confirmText={t('Confirm')} />
      <PayPalScriptProvider
        options={{
          "client-id": "AXJH0XLfIQefO-O3obqciwPayC7TRkf-ItSz8AmYhBR3X7sTYntScegm1CsC2JUNHR9fTZ9RBb039Gjl",
          currency: "USD",
          "disable-funding": "paylater",
          "enable-funding": "card"
        }}
      >
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "rect", label: "paypal" }}
          createOrder={async () => {
            const data = await post('/payment/create-order', {
              accessToken: user.accessToken,
              userId: user.userId,
              year: TaxYear,
              clientId: user.clientID,
              mobile: false
            });
            return data.id;
          }}
          onApprove={async (data) => {
            const response = await post('/payment/capture-order', {
              accessToken: user.accessToken,
              userId: user.userId,
              orderID: data.orderID
            });

            if (response.status === 'COMPLETED') {
              setIsError(false);
              setIsModalOpen(true);
            }
            else {
              setIsError(true);
              setIsModalOpen(true);
            }

          }}
          onError={(err) => {
            setIsError(true);
            setIsModalOpen(true);
          }}
        />
      </PayPalScriptProvider>
    </>
  );
};

export default PayPalCheckoutButton;